"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useItemView } from "../ItemViewProvider";
import { ProfileItemsGridSkeleton } from "./ProfileItemsGrid/ProfileItemsGridSkeleton";
import { useProfileItemsSelectionStore } from "./ProfileItemsSelectionProvider";
import { ProfileItemsTableSkeleton } from "./ProfileItemsTable/ProfileItemsTableSkeleton";
export function ProfileItemsListSkeleton() {
  const $ = _c(5);
  const {
    itemViewGroup
  } = useItemView();
  const setIsLoadingItems = useProfileItemsSelectionStore(_temp);
  let t0;
  let t1;
  if ($[0] !== setIsLoadingItems) {
    t0 = () => {
      setIsLoadingItems(true);
      return () => setIsLoadingItems(false);
    };
    t1 = [setIsLoadingItems];
    $[0] = setIsLoadingItems;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  if (itemViewGroup === "table") {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ProfileItemsTableSkeleton />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProfileItemsGridSkeleton />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(store) {
  return store.setIsLoadingItems;
}